import { Outlet } from "react-router-dom";
import { useBlockBrowserHistoryNavigation } from "../../hooks/useBlockBrowserHistoryNavigation.ts";

/**
 * Envuelve las rutas de /nomina para bloquear atrás/adelante del navegador.
 */
export function NominaHistoryGuard() {
  useBlockBrowserHistoryNavigation(true);
  return <Outlet />;
}
